import { ChangeLog, ChangeLogView } from "src/components/change-log/ChangeLog";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectParams } from "src/routes/routesDef";

export function ProjectChangeLogPage() {
  // Then get the project id
  const { projectId } = useRouteParams<ProjectParams>();

  return <ChangeLog view={ChangeLogView.Project} projectId={projectId} />;
}
